// extracted by mini-css-extract-plugin
export var closing = "EsuTpTUS6i1wlmp2wCFA";
export var desktop = "snpUSpBSi31yb7cGTRIC";
export var desktopSlideDown = "CY0TqMk_t9AcUJJmCYrw";
export var desktopSlideDownDialogFallback = "ZFrHMqy6JhKig9BNAdTS";
export var desktopSlideUp = "lCUSsjdtrDBih1PCKKrA";
export var desktopSlideUpDialogFallback = "BosuTrw1SgvAvLvNrOcC";
export var dialog = "XgTclgLDRgd_nvS8ekxm";
export var fadeIn = "ddU3trLPU359dSU7F3C2";
export var fadeOut = "fR4b4ZpHp9pSFsA7fxw2";
export var large = "IVlQAMB3D1S9t0LUyw0A";
export var medium = "hm3_ZyKnfH_yHgI0kSB7";
export var mobile = "FzM_hlBiov7S70XIfP2W";
export var mobileModalContainer = "fzbuxpTkcaPS9NO2aggR";
export var modal = "a8mSlCxUlGElQAN3JV9F";
export var noColourOverlay = "_6LPmtRQ1IJ2rnVzu4G6";
export var notResizable = "olpxlUF3AO7cnFVdYTEv";
export var opening = "vMb2FAprw6l2rbJpPxRJ";
export var small = "ScAG0g3PZYaBikjpJ7Ho";
export var smallMobileSlideDown = "bnJ1RhdmclD8Mpod7BCO";
export var smallMobileSlideUp = "It9pCkQxDT2ZWqulOha1";